import {
    enumMapper,
    IQueueItem,
    IQueueItemIdentifier,
    PriorityType,
    ProcessingExceptionType,
    ReviewStatus,
    ReviewTransactionStatus,
    TransactionStatus,
} from '@models';
import { IFilterModel } from '@uipath/angular/components/ui-grid';

export const REVIEW_STATUS_OPTIONS = enumMapper(ReviewStatus, {
    resourceKey: 'ReviewStatus',
});

export const PRIORITY_TYPE_OPTIONS = enumMapper(PriorityType, {
    resourceKey: 'PriorityType',
});

export const PROCESSING_EXCEPTION_TYPE_OPTIONS = enumMapper(ProcessingExceptionType, {
    resourceKey: 'ProcessingExceptionType',
});

export const DEFAULT_REVIEW_STATUS = 'InReview';
export const EXCLUDED_REVIEW_STATUS = 'Deleted';
export const DEFAULT_EXPAND = ['Robot', 'ReviewerUser'];

export const transactionStatusFor =
    (isReviewMode: boolean) =>
        enumMapper(
            isReviewMode ?
                ReviewTransactionStatus :
                TransactionStatus, {
                resourceKey: 'TransactionStatus',
            });

export const excludedReviewStatus = (isReviewMode: boolean) => (
    isReviewMode ? [{
        method: 'ne',
        property: 'status',
        value: transactionStatusFor(false).find(ts => ts.label === EXCLUDED_REVIEW_STATUS)!.value as string,
    }] : []
) as IFilterModel<IQueueItem>[];



export const queueItemToIdentifier = (item: IQueueItem): IQueueItemIdentifier => ({
    id: item.id,
    rowVersion: item.rowVersion,
    reviewer: item.reviewerUser,
});
